// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.0 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: var(--font-sans), sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: var(--font-mono), monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

:root {
  --radius: 1.5rem;
  --font-sans: Inter;
  --font-serif: ;
  --font-mono: Fira Code;
  --color-background: 255 255 255;
  --color-foreground: 71 85 105;
  --color-black: 2 6 23;
  --color-white: 255 255 255;
  --color-surface: 226 232 240;
  --color-surface-dark: 203 213 225;
  --color-surface-light: 241 245 249;
  --color-surface-foreground: 2 6 23;
  --color-primary: 30 41 59;
  --color-primary-dark: 15 23 42;
  --color-primary-light: 51 65 85;
  --color-primary-foreground: 248 250 252;
  --color-secondary: 226 232 240;
  --color-secondary-dark: 203 213 225;
  --color-secondary-light: 241 245 249;
  --color-secondary-foreground: 2 6 23;
  --color-info: 0 98 255;
  --color-info-dark: 0 85 221;
  --color-info-light: 0 122 255;
  --color-info-foreground: 248 250 252;
  --color-success: 0 191 107;
  --color-success-dark: 0 163 95;
  --color-success-light: 2 229 133;
  --color-success-foreground: 248 250 252;
  --color-warning: 252 163 39;
  --color-warning-dark: 246 125 10;
  --color-warning-light: 253 186 76;
  --color-warning-foreground: 248 250 252;
  --color-error: 239 68 68;
  --color-error-dark: 220 38 38;
  --color-error-light: 248 113 113;
  --color-error-foreground: 248 250 252;
}

.dark {
  --color-background: 2 6 23;
  --color-foreground: 148 163 184;
  --color-black: 2 6 23;
  --color-white: 255 255 255;
  --color-surface: 30 41 59;
  --color-surface-dark: 15 23 42;
  --color-surface-light: 51 65 85;
  --color-surface-foreground: 248 250 252;
  --color-primary: 226 232 240;
  --color-primary-dark: 203 213 225;
  --color-primary-light: 241 245 249;
  --color-primary-foreground: 2 6 23;
  --color-secondary: 30 41 59;
  --color-secondary-dark: 15 23 42;
  --color-secondary-light: 51 65 85;
  --color-secondary-foreground: 248 250 252;
  --color-info: 0 98 255;
  --color-info-dark: 0 85 221;
  --color-info-light: 0 122 255;
  --color-info-foreground: 248 250 252;
  --color-success: 0 191 107;
  --color-success-dark: 0 163 95;
  --color-success-light: 2 229 133;
  --color-success-foreground: 248 250 252;
  --color-warning: 252 163 39;
  --color-warning-dark: 246 125 10;
  --color-warning-light: 253 186 76;
  --color-warning-foreground: 248 250 252;
  --color-error: 239 68 68;
  --color-error-dark: 220 38 38;
  --color-error-light: 248 113 113;
  --color-error-foreground: 248 250 252;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.pointer-events-none {
  pointer-events: none;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.-right-2 {
  right: -0.5rem;
}
.-top-2 {
  top: -0.5rem;
}
.bottom-\\[14\\%\\] {
  bottom: 14%;
}
.bottom-\\[6\\%\\] {
  bottom: 6%;
}
.left-1\\/2 {
  left: 50%;
}
.left-2\\/4 {
  left: 50%;
}
.left-\\[14\\%\\] {
  left: 14%;
}
.left-\\[6\\%\\] {
  left: 6%;
}
.right-\\[14\\%\\] {
  right: 14%;
}
.right-\\[6\\%\\] {
  right: 6%;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-2\\/4 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[6\\%\\] {
  top: 6%;
}
.z-10 {
  z-index: 10;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[9997\\] {
  z-index: 9997;
}
.z-\\[9998\\] {
  z-index: 9998;
}
.col-span-full {
  grid-column: 1 / -1;
}
.m-1 {
  margin: 0.25rem;
}
.m-1\\.5 {
  margin: 0.375rem;
}
.m-2 {
  margin: 0.5rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-2\\.5 {
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-2\\.5 {
  margin-inline-end: 0.625rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.ms-0 {
  margin-inline-start: 0px;
}
.ms-0\\.5 {
  margin-inline-start: 0.125rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-1\\.5 {
  margin-inline-start: 0.375rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.hidden {
  display: none;
}
.size-12 {
  width: 3rem;
  height: 3rem;
}
.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.size-full {
  width: 100%;
  height: 100%;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[1em\\] {
  height: 1em;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[calc\\(100vh-200px\\)\\] {
  max-height: calc(100vh - 200px);
}
.max-h-\\[calc\\(100vh-32px\\)\\] {
  max-height: calc(100vh - 32px);
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-3 {
  min-height: 0.75rem;
}
.min-h-\\[30px\\] {
  min-height: 30px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[38px\\] {
  min-height: 38px;
}
.min-h-\\[46px\\] {
  min-height: 46px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.w-10 {
  width: 2.5rem;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-11 {
  width: 2.75rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-8\\/12 {
  width: 66.666667%;
}
.w-80 {
  width: 20rem;
}
.w-9\\/12 {
  width: 75%;
}
.w-\\[1em\\] {
  width: 1em;
}
.w-\\[calc\\(100\\%-16px\\)\\] {
  width: calc(100% - 16px);
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-3 {
  min-width: 0.75rem;
}
.min-w-40 {
  min-width: 10rem;
}
.min-w-60 {
  min-width: 15rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[30px\\] {
  min-width: 30px;
}
.min-w-\\[34px\\] {
  min-width: 34px;
}
.min-w-\\[38px\\] {
  min-width: 38px;
}
.min-w-\\[46px\\] {
  min-width: 46px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.flex-1 {
  flex: 1 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.-translate-x-0 {
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-0\\.5 {
  --tw-translate-x: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1 {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\.5 {
  --tw-translate-x: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\.5 {
  --tw-translate-x: 0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[3px\\] {
  --tw-translate-y: 3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: calc(var(--radius) - 20px);
}
.rounded-full {
  border-radius: calc(var(--radius) * 1000);
}
.rounded-lg {
  border-radius: calc(var(--radius) - 16px);
}
.rounded-md {
  border-radius: calc(var(--radius) - 18px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 22px);
}
.rounded-xl {
  border-radius: calc(var(--radius) - 12px);
}
.rounded-bl {
  border-bottom-left-radius: calc(var(--radius) - 20px);
}
.rounded-bl-sm {
  border-bottom-left-radius: calc(var(--radius) - 22px);
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-\\[inherit\\] {
  border-color: inherit;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-black) / var(--tw-border-opacity));
}
.border-blue-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity));
}
.border-current {
  border-color: currentColor;
}
.border-error {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}
.border-error-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-dark) / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-info {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity));
}
.border-info-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info-dark) / var(--tw-border-opacity));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}
.border-primary-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-dark) / var(--tw-border-opacity));
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}
.border-secondary-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary-dark) / var(--tw-border-opacity));
}
.border-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}
.border-success-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success-dark) / var(--tw-border-opacity));
}
.border-surface {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-surface) / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}
.border-warning-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning-dark) / var(--tw-border-opacity));
}
.border-e-transparent {
  border-inline-end-color: transparent;
}
.bg-background {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background) / var(--tw-bg-opacity));
}
.bg-background\\/10 {
  background-color: rgb(var(--color-background) / 0.1);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-black) / var(--tw-bg-opacity));
}
.bg-black\\/50 {
  background-color: rgb(var(--color-black) / 0.5);
}
.bg-blue-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity));
}
.bg-error {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}
.bg-error\\/10 {
  background-color: rgb(var(--color-error) / 0.1);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-info {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}
.bg-info\\/10 {
  background-color: rgb(var(--color-info) / 0.1);
}
.bg-inherit {
  background-color: inherit;
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}
.bg-primary\\/10 {
  background-color: rgb(var(--color-primary) / 0.1);
}
.bg-primary\\/5 {
  background-color: rgb(var(--color-primary) / 0.05);
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}
.bg-secondary\\/10 {
  background-color: rgb(var(--color-secondary) / 0.1);
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}
.bg-success\\/10 {
  background-color: rgb(var(--color-success) / 0.1);
}
.bg-surface {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface) / var(--tw-bg-opacity));
}
.bg-surface-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-light) / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}
.bg-warning\\/10 {
  background-color: rgb(var(--color-warning) / 0.1);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-white) / var(--tw-bg-opacity));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-error-dark {
  --tw-gradient-from: rgb(var(--color-error-dark) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-error-dark) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-info-dark {
  --tw-gradient-from: rgb(var(--color-info-dark) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-info-dark) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-dark {
  --tw-gradient-from: rgb(var(--color-primary-dark) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-primary-dark) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-secondary-dark {
  --tw-gradient-from: rgb(var(--color-secondary-dark) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-secondary-dark) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-success-dark {
  --tw-gradient-from: rgb(var(--color-success-dark) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-success-dark) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-warning-dark {
  --tw-gradient-from: rgb(var(--color-warning-dark) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-warning-dark) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-error-light {
  --tw-gradient-to: rgb(var(--color-error-light) / 1) var(--tw-gradient-to-position);
}
.to-info-light {
  --tw-gradient-to: rgb(var(--color-info-light) / 1) var(--tw-gradient-to-position);
}
.to-primary-light {
  --tw-gradient-to: rgb(var(--color-primary-light) / 1) var(--tw-gradient-to-position);
}
.to-secondary-light {
  --tw-gradient-to: rgb(var(--color-secondary-light) / 1) var(--tw-gradient-to-position);
}
.to-success-light {
  --tw-gradient-to: rgb(var(--color-success-light) / 1) var(--tw-gradient-to-position);
}
.to-warning-light {
  --tw-gradient-to: rgb(var(--color-warning-light) / 1) var(--tw-gradient-to-position);
}
.bg-clip-text {
  background-clip: text;
}
.stroke-2 {
  stroke-width: 2;
}
.stroke-\\[1\\.5\\] {
  stroke-width: 1.5;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-px {
  padding: 1px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-3\\.5 {
  padding-bottom: 0.875rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-2\\.5 {
  padding-inline-start: 0.625rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.align-\\[-0\\.125em\\] {
  vertical-align: -0.125em;
}
.font-sans {
  font-family: var(--font-sans), sans-serif;
}
.text-12 {
  font-size: 12px;
}
.text-14 {
  font-size: 14px;
}
.text-16 {
  font-size: 16px;
}
.text-18 {
  font-size: 18px;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.leading-none {
  line-height: 1;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
.text-blue-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity));
}
.text-current {
  color: currentColor;
}
.text-error {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error) / var(--tw-text-opacity));
}
.text-error-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-foreground) / var(--tw-text-opacity));
}
.text-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-foreground) / var(--tw-text-opacity));
}
.text-foreground\\/70 {
  color: rgb(var(--color-foreground) / 0.7);
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-info {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info) / var(--tw-text-opacity));
}
.text-info-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-foreground) / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}
.text-primary-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-foreground) / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-secondary) / var(--tw-text-opacity));
}
.text-secondary-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-secondary-foreground) / var(--tw-text-opacity));
}
.text-success {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity));
}
.text-success-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-foreground) / var(--tw-text-opacity));
}
.text-surface {
  --tw-text-opacity: 1;
  color: rgb(var(--color-surface) / var(--tw-text-opacity));
}
.text-surface-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-surface-foreground) / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-warning {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity));
}
.text-warning-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-foreground) / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-0 {
  opacity: 0;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black\\/10 {
  --tw-shadow-color: rgb(var(--color-black) / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/5 {
  --tw-shadow-color: rgb(var(--color-black) / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/\\[0\\.025\\] {
  --tw-shadow-color: rgb(var(--color-black) / 0.025);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-error-dark\\/25 {
  --tw-shadow-color: rgb(var(--color-error-dark) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-error\\/25 {
  --tw-shadow-color: rgb(var(--color-error) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-info-dark\\/25 {
  --tw-shadow-color: rgb(var(--color-info-dark) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-info\\/25 {
  --tw-shadow-color: rgb(var(--color-info) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-dark\\/25 {
  --tw-shadow-color: rgb(var(--color-primary-dark) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/25 {
  --tw-shadow-color: rgb(var(--color-primary) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-secondary-dark\\/25 {
  --tw-shadow-color: rgb(var(--color-secondary-dark) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-secondary\\/25 {
  --tw-shadow-color: rgb(var(--color-secondary) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-success-dark\\/25 {
  --tw-shadow-color: rgb(var(--color-success-dark) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-success\\/25 {
  --tw-shadow-color: rgb(var(--color-success) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-transparent {
  --tw-shadow-color: transparent;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-warning-dark\\/25 {
  --tw-shadow-color: rgb(var(--color-warning-dark) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-warning\\/25 {
  --tw-shadow-color: rgb(var(--color-warning) / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-transparent {
  --tw-ring-color: transparent;
}
.brightness-90 {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.\\[clip-path\\:polygon\\(0_0\\2c _100\\%_100\\%\\2c _0_100\\%\\)\\] {
  clip-path: polygon(0 0, 100% 100%, 0 100%);
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5f7;
}

* {
  box-sizing: border-box;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.03);
}

html {
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

::-webkit-scrollbar {
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  margin: 0 12px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  border: 2px solid rgba(245, 245, 247, 0.8);
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

.bg-toast {
  border-radius: 8px !important;
  border: 1px solid #00000020 !important;
  box-shadow: 4px 10px 30px rgba(0, 0, 0, 0.3) !important;
  background: white !important;
  color: black !important;
  font-size: 14px !important;
}

.bg-gradient-title {
  background-image: linear-gradient(90deg,#5f89e4,#b565fb 50%,#e00087);
}

.bg-clip-text {
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.placeholder\\:text-foreground\\/60::placeholder {
  color: rgb(var(--color-foreground) / 0.6);
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:-top-2::before {
  content: var(--tw-content);
  top: -0.5rem;
}

.before\\:-top-2\\.5::before {
  content: var(--tw-content);
  top: -0.625rem;
}

.before\\:-top-3::before {
  content: var(--tw-content);
  top: -0.75rem;
}

.before\\:-top-3\\.5::before {
  content: var(--tw-content);
  top: -0.875rem;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:left-1\\/2::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:inline-block::before {
  content: var(--tw-content);
  display: inline-block;
}

.before\\:h-1::before {
  content: var(--tw-content);
  height: 0.25rem;
}

.before\\:h-2::before {
  content: var(--tw-content);
  height: 0.5rem;
}

.before\\:h-2\\.5::before {
  content: var(--tw-content);
  height: 0.625rem;
}

.before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}

.before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}

.before\\:w-0\\.5::before {
  content: var(--tw-content);
  width: 0.125rem;
}

.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

.before\\:w-px::before {
  content: var(--tw-content);
  width: 1px;
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: calc(var(--radius) * 1000);
}

.before\\:bg-error::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}

.before\\:bg-info::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}

.before\\:bg-primary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.before\\:bg-secondary::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.before\\:bg-success::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.before\\:bg-surface::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface) / var(--tw-bg-opacity));
}

.before\\:bg-warning::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.before\\:transition-colors::before {
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:duration-200::before {
  content: var(--tw-content);
  transition-duration: 200ms;
}

.before\\:ease-in::before {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}

.after\\:top-2\\/4::after {
  content: var(--tw-content);
  top: 50%;
}

.after\\:h-6::after {
  content: var(--tw-content);
  height: 1.5rem;
}

.after\\:w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}

.after\\:-translate-y-2\\/4::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: calc(var(--radius) * 1000);
}

.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-surface::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-surface) / var(--tw-border-opacity));
}

.after\\:bg-background::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-background) / var(--tw-bg-opacity));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:duration-200::after {
  content: var(--tw-content);
  transition-duration: 200ms;
}

.after\\:ease-in::after {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.checked\\:before\\:bg-error:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-info:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-primary:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-secondary:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-success:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-warning:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.checked\\:after\\:translate-x-full:checked::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.checked\\:after\\:border-error:checked::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}

.checked\\:after\\:border-info:checked::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity));
}

.checked\\:after\\:border-primary:checked::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.checked\\:after\\:border-secondary:checked::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}

.checked\\:after\\:border-success:checked::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.checked\\:after\\:border-warning:checked::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.hover\\:border-error:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}

.hover\\:border-error-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error-light) / var(--tw-border-opacity));
}

.hover\\:border-error\\/10:hover {
  border-color: rgb(var(--color-error) / 0.1);
}

.hover\\:border-info:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity));
}

.hover\\:border-info-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info-light) / var(--tw-border-opacity));
}

.hover\\:border-info\\/10:hover {
  border-color: rgb(var(--color-info) / 0.1);
}

.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.hover\\:border-primary-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary-light) / var(--tw-border-opacity));
}

.hover\\:border-primary\\/5:hover {
  border-color: rgb(var(--color-primary) / 0.05);
}

.hover\\:border-primary\\/50:hover {
  border-color: rgb(var(--color-primary) / 0.5);
}

.hover\\:border-red-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}

.hover\\:border-secondary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}

.hover\\:border-secondary-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary-light) / var(--tw-border-opacity));
}

.hover\\:border-secondary\\/10:hover {
  border-color: rgb(var(--color-secondary) / 0.1);
}

.hover\\:border-success:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.hover\\:border-success-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success-light) / var(--tw-border-opacity));
}

.hover\\:border-success\\/10:hover {
  border-color: rgb(var(--color-success) / 0.1);
}

.hover\\:border-warning:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.hover\\:border-warning-light:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning-light) / var(--tw-border-opacity));
}

.hover\\:border-warning\\/10:hover {
  border-color: rgb(var(--color-warning) / 0.1);
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}

.hover\\:bg-error:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}

.hover\\:bg-error-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error-light) / var(--tw-bg-opacity));
}

.hover\\:bg-error\\/10:hover {
  background-color: rgb(var(--color-error) / 0.1);
}

.hover\\:bg-info:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}

.hover\\:bg-info-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info-light) / var(--tw-bg-opacity));
}

.hover\\:bg-info\\/10:hover {
  background-color: rgb(var(--color-info) / 0.1);
}

.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.hover\\:bg-primary-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-light) / var(--tw-bg-opacity));
}

.hover\\:bg-primary\\/5:hover {
  background-color: rgb(var(--color-primary) / 0.05);
}

.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.hover\\:bg-secondary-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary-light) / var(--tw-bg-opacity));
}

.hover\\:bg-secondary\\/10:hover {
  background-color: rgb(var(--color-secondary) / 0.1);
}

.hover\\:bg-success:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.hover\\:bg-success-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success-light) / var(--tw-bg-opacity));
}

.hover\\:bg-success\\/10:hover {
  background-color: rgb(var(--color-success) / 0.1);
}

.hover\\:bg-surface:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface) / var(--tw-bg-opacity));
}

.hover\\:bg-warning:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.hover\\:bg-warning-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning-light) / var(--tw-bg-opacity));
}

.hover\\:bg-warning\\/10:hover {
  background-color: rgb(var(--color-warning) / 0.1);
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}

.hover\\:text-error-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-foreground) / var(--tw-text-opacity));
}

.hover\\:text-info-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-foreground) / var(--tw-text-opacity));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.hover\\:text-primary-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-foreground) / var(--tw-text-opacity));
}

.hover\\:text-success-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-foreground) / var(--tw-text-opacity));
}

.hover\\:text-warning-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-foreground) / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-none:hover {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:ring-error\\/10:hover {
  --tw-ring-color: rgb(var(--color-error) / 0.1);
}

.hover\\:ring-info\\/10:hover {
  --tw-ring-color: rgb(var(--color-info) / 0.1);
}

.hover\\:ring-primary\\/10:hover {
  --tw-ring-color: rgb(var(--color-primary) / 0.1);
}

.hover\\:ring-secondary\\/10:hover {
  --tw-ring-color: rgb(var(--color-secondary) / 0.1);
}

.hover\\:ring-success\\/10:hover {
  --tw-ring-color: rgb(var(--color-success) / 0.1);
}

.hover\\:ring-warning\\/10:hover {
  --tw-ring-color: rgb(var(--color-warning) / 0.1);
}

.hover\\:brightness-105:hover {
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:border-error:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}

.focus\\:border-info:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity));
}

.focus\\:border-primary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.focus\\:border-secondary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}

.focus\\:border-success:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.focus\\:border-warning:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.focus\\:bg-primary:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.focus\\:bg-surface:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface) / var(--tw-bg-opacity));
}

.focus\\:text-black:focus {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}

.focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-error\\/10:focus {
  --tw-ring-color: rgb(var(--color-error) / 0.1);
}

.focus\\:ring-info\\/10:focus {
  --tw-ring-color: rgb(var(--color-info) / 0.1);
}

.focus\\:ring-primary\\/10:focus {
  --tw-ring-color: rgb(var(--color-primary) / 0.1);
}

.focus\\:ring-secondary\\/10:focus {
  --tw-ring-color: rgb(var(--color-secondary) / 0.1);
}

.focus\\:ring-success\\/10:focus {
  --tw-ring-color: rgb(var(--color-success) / 0.1);
}

.focus\\:ring-warning\\/10:focus {
  --tw-ring-color: rgb(var(--color-warning) / 0.1);
}

.active\\:bg-primary:active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.active\\:text-white:active {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

.active\\:ring-error\\/10:active {
  --tw-ring-color: rgb(var(--color-error) / 0.1);
}

.active\\:ring-info\\/10:active {
  --tw-ring-color: rgb(var(--color-info) / 0.1);
}

.active\\:ring-primary\\/10:active {
  --tw-ring-color: rgb(var(--color-primary) / 0.1);
}

.active\\:ring-secondary\\/10:active {
  --tw-ring-color: rgb(var(--color-secondary) / 0.1);
}

.active\\:ring-success\\/10:active {
  --tw-ring-color: rgb(var(--color-success) / 0.1);
}

.active\\:ring-warning\\/10:active {
  --tw-ring-color: rgb(var(--color-warning) / 0.1);
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:block {
  display: block;
}

.peer:hover ~ .peer-hover\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}

.aria-disabled\\:pointer-events-none[aria-disabled="true"] {
  pointer-events: none;
}

.aria-disabled\\:cursor-not-allowed[aria-disabled="true"] {
  cursor: not-allowed;
}

.aria-disabled\\:select-none[aria-disabled="true"] {
  -webkit-user-select: none;
          user-select: none;
}

.aria-disabled\\:opacity-50[aria-disabled="true"] {
  opacity: 0.5;
}

.data-\\[orientation\\=horizontal\\]\\:left-0[data-orientation=horizontal] {
  left: 0px;
}

.data-\\[orientation\\=horizontal\\]\\:top-1\\/2[data-orientation=horizontal] {
  top: 50%;
}

.data-\\[orientation\\=vertical\\]\\:left-1\\/2[data-orientation=vertical] {
  left: 50%;
}

.data-\\[orientation\\=vertical\\]\\:top-0[data-orientation=vertical] {
  top: 0px;
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:bottom-\\[14\\%\\][data-overlap='circular'][data-placement='bottom-end'] {
  bottom: 14%;
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:right-\\[14\\%\\][data-overlap='circular'][data-placement='bottom-end'] {
  right: 14%;
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:bottom-\\[6\\%\\][data-overlap='square'][data-placement='bottom-end'] {
  bottom: 6%;
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:right-\\[6\\%\\][data-overlap='square'][data-placement='bottom-end'] {
  right: 6%;
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:bottom-\\[14\\%\\][data-overlap='circular'][data-placement='bottom-start'] {
  bottom: 14%;
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:left-\\[14\\%\\][data-overlap='circular'][data-placement='bottom-start'] {
  left: 14%;
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:bottom-\\[6\\%\\][data-overlap='square'][data-placement='bottom-start'] {
  bottom: 6%;
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:left-\\[6\\%\\][data-overlap='square'][data-placement='bottom-start'] {
  left: 6%;
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:right-\\[14\\%\\][data-overlap='circular'][data-placement='top-end'] {
  right: 14%;
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:top-\\[14\\%\\][data-overlap='circular'][data-placement='top-end'] {
  top: 14%;
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:right-\\[6\\%\\][data-overlap='square'][data-placement='top-end'] {
  right: 6%;
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:top-\\[6\\%\\][data-overlap='square'][data-placement='top-end'] {
  top: 6%;
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:left-\\[14\\%\\][data-overlap='circular'][data-placement='top-start'] {
  left: 14%;
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:top-\\[14\\%\\][data-overlap='circular'][data-placement='top-start'] {
  top: 14%;
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:left-\\[6\\%\\][data-overlap='square'][data-placement='top-start'] {
  left: 6%;
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:top-\\[6\\%\\][data-overlap='square'][data-placement='top-start'] {
  top: 6%;
}

.data-\\[placement\\=bottom\\]\\:bottom-0[data-placement=bottom] {
  bottom: 0px;
}

.data-\\[placement\\=bottom\\]\\:left-0[data-placement=bottom] {
  left: 0px;
}

.data-\\[placement\\=end\\]\\:right-2[data-placement=end] {
  right: 0.5rem;
}

.data-\\[placement\\=end\\]\\:right-2\\.5[data-placement=end] {
  right: 0.625rem;
}

.data-\\[placement\\=end\\]\\:right-3[data-placement=end] {
  right: 0.75rem;
}

.data-\\[placement\\=left\\]\\:left-0[data-placement=left] {
  left: 0px;
}

.data-\\[placement\\=left\\]\\:top-0[data-placement=left] {
  top: 0px;
}

.data-\\[placement\\=right\\]\\:right-0[data-placement=right] {
  right: 0px;
}

.data-\\[placement\\=right\\]\\:top-0[data-placement=right] {
  top: 0px;
}

.data-\\[placement\\=start\\]\\:left-2[data-placement=start] {
  left: 0.5rem;
}

.data-\\[placement\\=start\\]\\:left-2\\.5[data-placement=start] {
  left: 0.625rem;
}

.data-\\[placement\\=start\\]\\:left-3[data-placement=start] {
  left: 0.75rem;
}

.data-\\[placement\\=top\\]\\:left-0[data-placement=top] {
  left: 0px;
}

.data-\\[placement\\=top\\]\\:top-0[data-placement=top] {
  top: 0px;
}

.data-\\[orientation\\=horizontal\\]\\:block[data-orientation=horizontal] {
  display: block;
}

.data-\\[orientation\\=vertical\\]\\:flex[data-orientation=vertical] {
  display: flex;
}

.data-\\[open\\=true\\]\\:h-auto[data-open=true] {
  height: auto;
}

.data-\\[orientation\\=horizontal\\]\\:h-0\\.5[data-orientation=horizontal] {
  height: 0.125rem;
}

.data-\\[orientation\\=vertical\\]\\:h-full[data-orientation=vertical] {
  height: 100%;
}

.data-\\[placement\\=left\\]\\:h-screen[data-placement=left] {
  height: 100vh;
}

.data-\\[placement\\=right\\]\\:h-screen[data-placement=right] {
  height: 100vh;
}

.data-\\[orientation\\=horizontal\\]\\:w-full[data-orientation=horizontal] {
  width: 100%;
}

.data-\\[orientation\\=vertical\\]\\:w-0\\.5[data-orientation=vertical] {
  width: 0.125rem;
}

.data-\\[placement\\=bottom\\]\\:w-screen[data-placement=bottom] {
  width: 100vw;
}

.data-\\[placement\\=top\\]\\:w-screen[data-placement=top] {
  width: 100vw;
}

.data-\\[width\\=full\\]\\:w-full[data-width=full] {
  width: 100%;
}

.data-\\[orientation\\=horizontal\\]\\:-translate-y-1\\/2[data-orientation=horizontal] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[orientation\\=vertical\\]\\:-translate-x-1\\/2[data-orientation=vertical] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:translate-x-1\\/2[data-overlap='circular'][data-placement='bottom-end'] {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:translate-y-1\\/2[data-overlap='circular'][data-placement='bottom-end'] {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:translate-x-1\\/2[data-overlap='square'][data-placement='bottom-end'] {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:translate-y-1\\/2[data-overlap='square'][data-placement='bottom-end'] {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:-translate-x-1\\/2[data-overlap='circular'][data-placement='bottom-start'] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:translate-y-1\\/2[data-overlap='circular'][data-placement='bottom-start'] {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:-translate-x-1\\/2[data-overlap='square'][data-placement='bottom-start'] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'bottom-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:translate-y-1\\/2[data-overlap='square'][data-placement='bottom-start'] {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:-translate-y-1\\/2[data-overlap='circular'][data-placement='top-end'] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:translate-x-1\\/2[data-overlap='circular'][data-placement='top-end'] {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:-translate-y-1\\/2[data-overlap='square'][data-placement='top-end'] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-end\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:translate-x-1\\/2[data-overlap='square'][data-placement='top-end'] {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:-translate-x-1\\/2[data-overlap='circular'][data-placement='top-start'] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'circular\\'\\]\\:-translate-y-1\\/2[data-overlap='circular'][data-placement='top-start'] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:-translate-x-1\\/2[data-overlap='square'][data-placement='top-start'] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\=\\'top-start\\'\\]\\:data-\\[overlap\\=\\'square\\'\\]\\:-translate-y-1\\/2[data-overlap='square'][data-placement='top-start'] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\^\\=bottom\\]\\:rotate-\\[135deg\\][data-placement^=bottom] {
  --tw-rotate: 135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\^\\=left\\]\\:rotate-\\[225deg\\][data-placement^=left] {
  --tw-rotate: 225deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\^\\=right\\]\\:rotate-45[data-placement^=right] {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[placement\\^\\=top\\]\\:-rotate-45[data-placement^=top] {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[checked\\=true\\]\\:scale-100[data-checked=true] {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[resize\\=true\\]\\:resize-y[data-resize=true] {
  resize: vertical;
}

.data-\\[orientation\\=horizontal\\]\\:flex-row[data-orientation=horizontal] {
  flex-direction: row;
}

.data-\\[orientation\\=vertical\\]\\:flex-row[data-orientation=vertical] {
  flex-direction: row;
}

.data-\\[orientation\\=horizontal\\]\\:flex-col[data-orientation=horizontal] {
  flex-direction: column;
}

.data-\\[orientation\\=vertical\\]\\:flex-col[data-orientation=vertical] {
  flex-direction: column;
}

.data-\\[orientation\\=vertical\\]\\:items-start[data-orientation=vertical] {
  align-items: flex-start;
}

.data-\\[orientation\\=horizontal\\]\\:items-center[data-orientation=horizontal] {
  align-items: center;
}

.data-\\[orientation\\=vertical\\]\\:gap-x-6[data-orientation=vertical] {
  column-gap: 1.5rem;
}

.data-\\[open\\=true\\]\\:overflow-visible[data-open=true] {
  overflow: visible;
}

.data-\\[pill\\=true\\]\\:rounded-full[data-pill=true] {
  border-radius: calc(var(--radius) * 1000);
}

.data-\\[shape\\=circular\\]\\:rounded-full[data-shape=circular] {
  border-radius: calc(var(--radius) * 1000);
}

.data-\\[shape\\=pill\\]\\:rounded-full[data-shape=pill] {
  border-radius: calc(var(--radius) * 1000);
}

.data-\\[shape\\=rounded\\]\\:rounded-\\[current\\][data-shape=rounded] {
  border-radius: current;
}

.data-\\[shape\\=square\\]\\:rounded-none[data-shape=square] {
  border-radius: 0px;
}

.data-\\[checked\\=true\\]\\:border-error[data-checked=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}

.data-\\[checked\\=true\\]\\:border-info[data-checked=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity));
}

.data-\\[checked\\=true\\]\\:border-primary[data-checked=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.data-\\[checked\\=true\\]\\:border-secondary[data-checked=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}

.data-\\[checked\\=true\\]\\:border-success[data-checked=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.data-\\[checked\\=true\\]\\:border-warning[data-checked=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.data-\\[error\\=true\\]\\:border-error[data-error=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}

.data-\\[open\\=true\\]\\:border-error[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-error) / var(--tw-border-opacity));
}

.data-\\[open\\=true\\]\\:border-info[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity));
}

.data-\\[open\\=true\\]\\:border-primary[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.data-\\[open\\=true\\]\\:border-secondary[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}

.data-\\[open\\=true\\]\\:border-success[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.data-\\[open\\=true\\]\\:border-warning[data-open=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.data-\\[success\\=true\\]\\:border-success[data-success=true] {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.data-\\[checked\\=true\\]\\:bg-error[data-checked=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}

.data-\\[checked\\=true\\]\\:bg-info[data-checked=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}

.data-\\[checked\\=true\\]\\:bg-primary[data-checked=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.data-\\[checked\\=true\\]\\:bg-secondary[data-checked=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.data-\\[checked\\=true\\]\\:bg-success[data-checked=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.data-\\[checked\\=true\\]\\:bg-warning[data-checked=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.data-\\[selected\\=true\\]\\:bg-surface[data-selected=true] {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface) / var(--tw-bg-opacity));
}

.data-\\[orientation\\=horizontal\\]\\:py-4[data-orientation=horizontal] {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.data-\\[icon-placement\\=end\\]\\:pe-11[data-icon-placement=end] {
  padding-inline-end: 2.75rem;
}

.data-\\[icon-placement\\=end\\]\\:pe-7[data-icon-placement=end] {
  padding-inline-end: 1.75rem;
}

.data-\\[icon-placement\\=end\\]\\:pe-9[data-icon-placement=end] {
  padding-inline-end: 2.25rem;
}

.data-\\[icon-placement\\=start\\]\\:ps-11[data-icon-placement=start] {
  padding-inline-start: 2.75rem;
}

.data-\\[icon-placement\\=start\\]\\:ps-7[data-icon-placement=start] {
  padding-inline-start: 1.75rem;
}

.data-\\[icon-placement\\=start\\]\\:ps-9[data-icon-placement=start] {
  padding-inline-start: 2.25rem;
}

.data-\\[orientation\\=vertical\\]\\:pb-8[data-orientation=vertical] {
  padding-bottom: 2rem;
}

.data-\\[selected\\=true\\]\\:text-black[data-selected=true] {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}

.data-\\[checked\\=true\\]\\:opacity-100[data-checked=true] {
  opacity: 1;
}

.data-\\[open\\=true\\]\\:ring-error\\/10[data-open=true] {
  --tw-ring-color: rgb(var(--color-error) / 0.1);
}

.data-\\[open\\=true\\]\\:ring-info\\/10[data-open=true] {
  --tw-ring-color: rgb(var(--color-info) / 0.1);
}

.data-\\[open\\=true\\]\\:ring-primary\\/10[data-open=true] {
  --tw-ring-color: rgb(var(--color-primary) / 0.1);
}

.data-\\[open\\=true\\]\\:ring-secondary\\/10[data-open=true] {
  --tw-ring-color: rgb(var(--color-secondary) / 0.1);
}

.data-\\[open\\=true\\]\\:ring-success\\/10[data-open=true] {
  --tw-ring-color: rgb(var(--color-success) / 0.1);
}

.data-\\[open\\=true\\]\\:ring-warning\\/10[data-open=true] {
  --tw-ring-color: rgb(var(--color-warning) / 0.1);
}

.group[data-checked=true] .group-data-\\[checked\\=true\\]\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:bg-error {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:bg-info {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:bg-error {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-error) / var(--tw-bg-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:bg-info {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:text-error-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-foreground) / var(--tw-text-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:text-info-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-foreground) / var(--tw-text-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:text-primary-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-foreground) / var(--tw-text-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:text-secondary-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-secondary-foreground) / var(--tw-text-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:text-success-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-foreground) / var(--tw-text-opacity));
}

.group[data-active=true] .group-data-\\[active\\=true\\]\\:text-warning-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-foreground) / var(--tw-text-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:text-error-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-error-foreground) / var(--tw-text-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:text-info-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info-foreground) / var(--tw-text-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:text-primary-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary-foreground) / var(--tw-text-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:text-secondary-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-secondary-foreground) / var(--tw-text-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:text-success-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-foreground) / var(--tw-text-opacity));
}

.group[data-completed=true] .group-data-\\[completed\\=true\\]\\:text-warning-foreground {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-foreground) / var(--tw-text-opacity));
}

.group[data-checked=true] .group-data-\\[checked\\=true\\]\\:opacity-100 {
  opacity: 1;
}

@media (min-width: 640px) {

  .sm\\:w-6\\/12 {
    width: 50%;
  }

  .sm\\:w-7\\/12 {
    width: 58.333333%;
  }
}

@media (min-width: 768px) {

  .md\\:w-4\\/12 {
    width: 33.333333%;
  }

  .md\\:w-5\\/12 {
    width: 41.666667%;
  }

  .md\\:w-8\\/12 {
    width: 66.666667%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:w-10\\/12 {
    width: 83.333333%;
  }

  .lg\\:w-3\\/12 {
    width: 25%;
  }

  .lg\\:w-6\\/12 {
    width: 50%;
  }

  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:w-2\\/12 {
    width: 16.666667%;
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

:is(:where(.dark) .dark\\:border-white) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-white) / var(--tw-border-opacity));
}

:is(:where(.dark) .dark\\:bg-surface) {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface) / var(--tw-bg-opacity));
}

:is(:where(.dark) .dark\\:bg-white) {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-white) / var(--tw-bg-opacity));
}

:is(:where(.dark) .dark\\:bg-opacity-70) {
  --tw-bg-opacity: 0.7;
}

:is(:where(.dark) .dark\\:text-black) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-black) / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:after\\:bg-white)::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-white) / var(--tw-bg-opacity));
}

:is(:where(.dark) .dark\\:hover\\:text-primary:hover) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:hover\\:text-white:hover) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:focus\\:text-white:focus) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

:is(:where(.dark) .peer:hover ~ .dark\\:peer-hover\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

:is(:where(.dark) .peer:focus ~ .dark\\:peer-focus\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

:is(:where(.dark) .dark\\:data-\\[selected\\=true\\]\\:text-white[data-selected=true]) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-white) / var(--tw-text-opacity));
}

.data-\\[orientation\\=horizontal\\]\\:\\[\\&\\:first-child\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:rounded-r-none *:first-child:not([data-variant=ghost])[data-orientation=horizontal] {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.data-\\[orientation\\=vertical\\]\\:\\[\\&\\:first-child\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:rounded-b-none *:first-child:not([data-variant=ghost])[data-orientation=vertical] {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.data-\\[orientation\\=horizontal\\]\\:\\[\\&\\:last-child\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:rounded-l-none *:last-child:not([data-variant=ghost])[data-orientation=horizontal] {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.data-\\[orientation\\=vertical\\]\\:\\[\\&\\:last-child\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:rounded-t-none *:last-child:not([data-variant=ghost])[data-orientation=vertical] {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.data-\\[orientation\\=horizontal\\]\\:\\[\\&\\:last-child\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:border-l-0 *:last-child:not([data-variant=ghost])[data-orientation=horizontal] {
  border-left-width: 0px;
}

.data-\\[orientation\\=vertical\\]\\:\\[\\&\\:last-child\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:border-t-0 *:last-child:not([data-variant=ghost])[data-orientation=vertical] {
  border-top-width: 0px;
}

.data-\\[orientation\\=horizontal\\]\\:\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:rounded-none *:not(:first-child):not(:last-child):not([data-variant=ghost])[data-orientation=horizontal] {
  border-radius: 0px;
}

.data-\\[orientation\\=vertical\\]\\:\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:rounded-none *:not(:first-child):not(:last-child):not([data-variant=ghost])[data-orientation=vertical] {
  border-radius: 0px;
}

.data-\\[orientation\\=horizontal\\]\\:\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:border-l-0 *:not(:first-child):not(:last-child):not([data-variant=ghost])[data-orientation=horizontal] {
  border-left-width: 0px;
}

.data-\\[orientation\\=vertical\\]\\:\\[\\&\\:not\\(\\:first-child\\)\\:not\\(\\:last-child\\)\\:not\\(\\[data-variant\\=ghost\\]\\)\\]\\:\\[\\&_\\*\\]\\:border-t-0 *:not(:first-child):not(:last-child):not([data-variant=ghost])[data-orientation=vertical] {
  border-top-width: 0px;
}

.\\[\\&_data-slot\\=icon\\]\\:h-5 data-slot=icon {
  height: 1.25rem;
}

.\\[\\&_data-slot\\=icon\\]\\:w-5 data-slot=icon {
  width: 1.25rem;
}

.\\[\\&_data-slot\\=icon\\]\\:cursor-pointer data-slot=icon {
  cursor: pointer;
}

.\\[\\&_data-slot\\=icon\\]\\:text-inherit data-slot=icon {
  color: inherit;
}

.\\[\\&_data-slot\\=placeholder\\]\\:text-foreground\\/60 data-slot=placeholder {
  color: rgb(var(--color-foreground) / 0.6);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,yCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,wCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,+BAAc;EAAd,6BAAc;EAAd,qBAAc;EAAd,0BAAc;EAAd,4BAAc;EAAd,iCAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,+BAAc;EAAd,uCAAc;EAAd,8BAAc;EAAd,mCAAc;EAAd,oCAAc;EAAd,oCAAc;EAAd,sBAAc;EAAd,2BAAc;EAAd,6BAAc;EAAd,oCAAc;EAAd,0BAAc;EAAd,8BAAc;EAAd,gCAAc;EAAd,uCAAc;EAAd,2BAAc;EAAd,gCAAc;EAAd,iCAAc;EAAd,uCAAc;EAAd,wBAAc;EAAd,6BAAc;EAAd,gCAAc;EAAd;AAAc;;AAAd;EAAA,0BAAc;EAAd,+BAAc;EAAd,qBAAc;EAAd,0BAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,+BAAc;EAAd,uCAAc;EAAd,4BAAc;EAAd,iCAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,gCAAc;EAAd,iCAAc;EAAd,yCAAc;EAAd,sBAAc;EAAd,2BAAc;EAAd,6BAAc;EAAd,oCAAc;EAAd,0BAAc;EAAd,8BAAc;EAAd,gCAAc;EAAd,uCAAc;EAAd,2BAAc;EAAd,gCAAc;EAAd,iCAAc;EAAd,uCAAc;EAAd,wBAAc;EAAd,6BAAc;EAAd,gCAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,cAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,mFAAmB;EAAnB;AAAmB;AAAnB;EAAA,yFAAmB;EAAnB,qFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,mFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,mFAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB;;gCAE8B;EAC9B,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,uDAAuD;EACvD,4BAA4B;EAC5B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAlEA;EAAA;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,+FAkEC;EAlED,wDAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,gBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,wBAkEC;EAlED,wDAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,0EAkEC;EAlED,8FAkEC;EAlED;AAkEC;;AAlED;EAAA,+EAkEC;EAlED,mGAkEC;EAlED;AAkEC;;AAlED;EAAA,6EAkEC;EAlED,iGAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED,8BAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,iCAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED,8BAkEC;EAlED;AAkEC;;AAlED;EAAA,8BAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED,8BAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,yBAkEC;UAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,qBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,mBAkEC;EAlED;AAkEC;;AAlED;EAAA,mBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,mBAkEC;EAlED;AAkEC;;AAlED;EAAA,eAkEC;EAlED,eAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,iBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,eAkEC;EAlED,eAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,eAkEC;IAlED;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA;EAkEC;;EAlED;IAAA,iBAkEC;IAlED;EAkEC;;EAlED;IAAA,mBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,eAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;;EAlED;IAAA,kBAkEC;IAlED;EAkEC;AAAA;;AAlED;;EAAA;IAAA;EAkEC;;EAlED;IAAA;EAkEC;AAAA;;AAlED;EAAA,sBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,kBAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,0BAkEC;EAlED,kBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,oBAkEC;EAlED;AAkEC;;AAlED;EAAA,4BAkEC;EAlED;AAkEC;;AAlED;EAAA,+BAkEC;EAlED;AAkEC;;AAlED;EAAA,2BAkEC;EAlED;AAkEC;;AAlED;EAAA,2BAkEC;EAlED;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC;;AAlED;EAAA;AAkEC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f5f5f7;\n}\n\n* {\n  box-sizing: border-box;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.03);\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n::-webkit-scrollbar {\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 10px;\n  margin: 0 12px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  border: 2px solid rgba(245, 245, 247, 0.8);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.bg-toast {\n  border-radius: 8px !important;\n  border: 1px solid #00000020 !important;\n  box-shadow: 4px 10px 30px rgba(0, 0, 0, 0.3) !important;\n  background: white !important;\n  color: black !important;\n  font-size: 14px !important;\n}\n\n.bg-gradient-title {\n  background-image: linear-gradient(90deg,#5f89e4,#b565fb 50%,#e00087);\n}\n\n.bg-clip-text {\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
